import styled, { css } from 'styled-components';
import { variant } from 'styled-system';
import { colors } from '@keen.io/colors';
import React from 'react';

var DEFAULT_LINE_HEIGHT = 1.2;
var DEFAULT_FONT_WEIGHT = 400;

var RESET_SPACING = css(["margin:0;padding:0;"]);
var TEXT_ELLIPSIS = css(["white-space:nowrap;text-overflow:ellipsis;overflow:hidden;"]);

var BodyText = styled.p.withConfig({
  displayName: "body-textcomponent__BodyText",
  componentId: "keen-typography__sc-1s1skvf-0"
})(["&&&{", ";font-family:'Lato',sans-serif;", ";", ";}"], RESET_SPACING, variant({
  variants: {
    body1: {
      fontSize: '16px',
      fontWeight: DEFAULT_FONT_WEIGHT
    },
    body2: {
      fontSize: '14px',
      fontWeight: DEFAULT_FONT_WEIGHT
    },
    body3: {
      fontSize: '12px',
      fontWeight: 600
    }
  }
}), function (props) {
  return css(["color:", ";line-height:", ";font-weight:", ";text-transform:", ";", ";"], props.color, props.lineHeight, props.fontWeight, props.textTransform, props.enableTextEllipsis && TEXT_ELLIPSIS);
});
BodyText.defaultProps = {
  lineHeight: DEFAULT_LINE_HEIGHT,
  color: colors.black[100],
  enableTextEllipsis: false,
  textTransform: 'none'
};

var FontWeight = styled.span.withConfig({
  displayName: "font-weightcomponent__FontWeight",
  componentId: "keen-typography__sc-17aikmi-0"
})(["&&&{", ";}"], function (props) {
  return props.fontWeight && css(["font-weight:", ";"], props.fontWeight);
});

var HEADER_STYLE = css(["", ";font-family:'Gangster Grotesk',sans-serif;font-weight:bold;line-height:", ";"], RESET_SPACING, DEFAULT_LINE_HEIGHT);

var StyledH1 = styled.h1.withConfig({
  displayName: "headlinecomponent__StyledH1",
  componentId: "keen-typography__sc-19bnutv-0"
})(["&&&{", ";font-size:36px;color:", ";", ";}"], HEADER_STYLE, colors.black[500], function (props) {
  return css(["color:", ";line-height:", ";font-weight:", ";", ";"], props.color, props.lineHeight, props.fontWeight, props.enableTextEllipsis && TEXT_ELLIPSIS);
});
var StyledH2 = styled.h2.withConfig({
  displayName: "headlinecomponent__StyledH2",
  componentId: "keen-typography__sc-19bnutv-1"
})(["&&&{", ";font-size:30px;color:", ";", ";}"], HEADER_STYLE, colors.black[500], function (props) {
  return css(["color:", ";line-height:", ";font-weight:", ";", ";"], props.color, props.lineHeight, props.fontWeight, props.enableTextEllipsis && TEXT_ELLIPSIS);
});
var StyledH3 = styled.h3.withConfig({
  displayName: "headlinecomponent__StyledH3",
  componentId: "keen-typography__sc-19bnutv-2"
})(["&&&{", ";font-size:20px;color:", ";", ";}"], HEADER_STYLE, colors.black[400], function (props) {
  return css(["color:", ";line-height:", ";font-weight:", ";", ";"], props.color, props.lineHeight, props.fontWeight, props.enableTextEllipsis && TEXT_ELLIPSIS);
});
var StyledH4 = styled.h4.withConfig({
  displayName: "headlinecomponent__StyledH4",
  componentId: "keen-typography__sc-19bnutv-3"
})(["&&&{", ";font-size:16px;color:", ";", ";}"], HEADER_STYLE, colors.black[400], function (props) {
  return css(["color:", ";line-height:", ";font-weight:", ";", ";"], props.color, props.lineHeight, props.fontWeight, props.enableTextEllipsis && TEXT_ELLIPSIS);
});
var Headline = function Headline(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'h1' : _ref$variant,
      fontWeight = _ref.fontWeight,
      lineHeight = _ref.lineHeight,
      _ref$textTransform = _ref.textTransform,
      textTransform = _ref$textTransform === void 0 ? 'none' : _ref$textTransform,
      color = _ref.color,
      _ref$enableTextEllips = _ref.enableTextEllipsis,
      enableTextEllipsis = _ref$enableTextEllips === void 0 ? false : _ref$enableTextEllips,
      children = _ref.children;

  switch (variant) {
    case 'h2':
      return React.createElement(StyledH2, {
        fontWeight: fontWeight,
        lineHeight: lineHeight,
        textTransform: textTransform,
        color: color,
        enableTextEllipsis: enableTextEllipsis
      }, children);

    case 'h3':
      return React.createElement(StyledH3, {
        fontWeight: fontWeight,
        lineHeight: lineHeight,
        textTransform: textTransform,
        color: color,
        enableTextEllipsis: enableTextEllipsis
      }, children);

    case 'h4':
      return React.createElement(StyledH4, {
        fontWeight: fontWeight,
        lineHeight: lineHeight,
        textTransform: textTransform,
        color: color,
        enableTextEllipsis: enableTextEllipsis
      }, children);

    default:
      return React.createElement(StyledH1, {
        fontWeight: fontWeight,
        lineHeight: lineHeight,
        textTransform: textTransform,
        color: color,
        enableTextEllipsis: enableTextEllipsis
      }, children);
  }
};

var Italic = styled.span.withConfig({
  displayName: "italiccomponent__Italic",
  componentId: "keen-typography__sc-3x900o-0"
})(["&&&{font-style:italic;}"]);

var Underline = styled.span.withConfig({
  displayName: "underlinecomponent__Underline",
  componentId: "keen-typography__sc-hj00a-0"
})(["&&&{text-decoration:underline;}"]);

export { BodyText, FontWeight, Headline, Italic, RESET_SPACING, TEXT_ELLIPSIS, Underline };
//# sourceMappingURL=index.esm.js.map
